import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper';

export const logsAnalysisService = {
  getServiceAnalysis: async (analysisType = 'bucket', timerange = '6h', accountId = null) => {
    try {
      const params = new URLSearchParams({
        analysis_type: analysisType,
        timerange,
      });
      if (accountId) {
        params.set('account_id', accountId);
      }
      const response = await fetchWrapper(
        `${API_BASE_URL}/api/v1/logs-analysis?${params.toString()}`
      );
      const data = await response.json();
      if (!response.ok) {
        const message = data?.detail || data?.error || 'Failed to fetch logs analysis data';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
      }
      return data;
    } catch (error) {
      console.error('Error fetching logs analysis data:', error);
      throw error;
    }
  },

  getCombinedAnalysis: async (timerange = '24h', accountId = null) => {
    try {
      const params = new URLSearchParams({
        analysis_type: 'combined',
        timerange,
      });
      if (accountId) {
        params.set('account_id', accountId);
      }
      const response = await fetchWrapper(
        `${API_BASE_URL}/api/v1/logs-analysis?${params.toString()}`
      );
      const data = await response.json();
      if (!response.ok) {
        const message = data?.detail || data?.error || 'Failed to fetch combined logs analysis data';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
      }
      return data;
    } catch (error) {
      console.error('Error fetching combined logs analysis data:', error);
      throw error;
    }
  },

  getLogCostAnalysis: async ({
    label = 'account_id',
    timerange = '24h',
    account_id = 'all',
    lambda_function_name = 'clairai-logs-to-loki-lambda',
  } = {}) => {
    try {
      const params = new URLSearchParams({
        label,
        timerange,
        account_id,
        lambda_function_name,
      });
      const response = await fetchWrapper(
        `${API_BASE_URL}/api/v1/granular-cost-analysis?${params.toString()}`
      );
      const data = await response.json();
      if (!response.ok) {
        const message = data?.detail || data?.error || 'Failed to fetch logs cost analysis data';
        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
      }
      return data;
    } catch (error) {
      console.error('Error fetching logs cost analysis data:', error);
      throw error;
    }
  },
};
